import { render, staticRenderFns } from "./ManagementReport.vue?vue&type=template&id=4f68d89b&scoped=true"
var script = {}
import style0 from "./ManagementReport.vue?vue&type=style&index=0&id=4f68d89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f68d89b",
  null
  
)

export default component.exports